// extracted by mini-css-extract-plugin
module.exports =  {"trigger":"trigger-AimsT","layer":"layer-MnZ5V","menu-container":"menu-container-EUaqA","option-container":"option-container-iHl6R","label":"label-SN0nf"};